export enum LoginDuplicatedEnum {
  OFFLINE = 0,
  ONLINE_DIFUSION = 1,
  RELOAD_PAGE = 2,
  LOGOUT = 3
}
